export const booleanPromise = async promise => promise.then(() => true)
  .catch(() => false);

export default { booleanPromise };
